/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_F1Inputs */

const en_mk_sol_agensi_f1 = /** @type {(inputs: Mk_Sol_Agensi_F1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 people: 4 account, 5 creative, 2 production, 1 owner`)
};

const id_mk_sol_agensi_f1 = /** @type {(inputs: Mk_Sol_Agensi_F1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 orang: 4 akun, 5 kreatif, 2 produksi, 1 pemilik`)
};

/**
* | output |
* | --- |
* | "12 people: 4 account, 5 creative, 2 production, 1 owner" |
*
* @param {Mk_Sol_Agensi_F1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_f1 = /** @type {((inputs?: Mk_Sol_Agensi_F1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_F1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_f1(inputs)
	return en_mk_sol_agensi_f1(inputs)
});